(function($){
	//Initialize slick for adventure carousels
	$('.adventure-carousel .slides').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		infinite: true,
		draggable: true,
		autoplay: true,
		autoplaySpeed: 4000,
		fade: true
	});
})(jQuery);
